import React from 'react';

export const formatDate = (date) => {
  try {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return '';
  }
};

export const formatShortDate = (date) => {
  try {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '';
  }
};

export const truncateText = (text, limit) => {
  if (text.length <= limit) {
    return text;
  }

  const lastSpaceIndex = text.substring(0, limit).lastIndexOf(' ');
  return text.substring(0, lastSpaceIndex) + '...';
};

let emptyIndex = 0;

export const padItems = (itemsArray, padding) => {
  if (itemsArray.length % padding > 0) {
    return new Array(padding - (itemsArray.length % padding))
      .fill(0)
      .map(() => <div key={'empty-' + emptyIndex++} className="empty" />);
  }
};

export const formatCategories = (categoriesArray) => {
  if (categoriesArray) {
    return categoriesArray.map((item, i, arr) => (
      <span key={i}>
        {item} {i != arr.length - 1 ? '  |  ' : ''}
      </span>
    ));
  } else {
    return;
  }
};
